export default "__VITE_PUBLIC_ASSET__67f01075__"